"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _styledComponents = require("styled-components");

var _stylers = _interopRequireDefault(require("@paprika/stylers"));

var focusStyles = function focusStyles(isInset) {
  return (0, _styledComponents.css)(["&:focus{", "}[data-whatinput=\"mouse\"] &:not([data-has-forced-focus=\"true\"]):focus{box-shadow:none;outline:none;}"], _stylers["default"].focusRing(isInset));
};

var disabledStyles = (0, _styledComponents.css)(["cursor:not-allowed;&:focus{box-shadow:none;}"]);
var rawButtonStyles = (0, _styledComponents.css)(["cursor:pointer;display:inline-block;", ";", ";"], function (_ref) {
  var hasInsetFocusStyle = _ref.hasInsetFocusStyle,
      isActive = _ref.isActive;
  return isActive ? _stylers["default"].focusRing(hasInsetFocusStyle) : focusStyles(hasInsetFocusStyle);
}, function (_ref2) {
  var isDisabled = _ref2.isDisabled;
  return isDisabled && disabledStyles;
});
var _default = rawButtonStyles;
exports["default"] = _default;
//# sourceMappingURL=RawButton.styles.js.map